import TableComponent, {
  useStylesExtraButton,
} from "app/common/Component/Table/TableComponent";
import { useStore } from "app/stores";
import React, { memo, useEffect, useState } from "react";
import { Button, Grid, Popover, Tooltip, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  getDateTime,
  getTime,
  isAdmin,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import IconPen from "app/common/Icon/IconPen";
import { observer } from "mobx-react";
import { ExpandMore, KeyboardArrowRight, Search } from "@material-ui/icons";
import {
  STATUS_PATIENT_ADVISE,
  STATUS_RESULT_PATIENT_ADVISE,
} from "app/common/LocalConst";
import GlobitsPagination from "app/common/Component/Table/Pagination";
import IconDelete from "app/common/Icon/IconDelete";
import FilterListIcon from "@material-ui/icons/FilterList";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgRotate from "lightgallery/plugins/rotate";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { pagingDepartment } from "app/services/DepartmentService";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
const ListAdvise = ({ isOpenFillter, setOpenFillter }) => {
  const { t } = useTranslation();
  const {
    searchAdvise,
    pageAdvise,
    handleChangeFormSearch,
    handleClearItemPatientAdvise,
    fetchImage,
    getImageUrl,
  } = useStore().patientManagementStore.listAdviseStore;
  const columns = {
    stt: "STT",
    acction: "thao tác",
    createdBy: "Người tư vấn",
    lastContent: "Nội dung tư vấn",
    status: "Trạng thái",
    interest: "Quan tâm",
    confirmed: "Đã chốt",
  };

  const dataInitColumn = {
    stt: true,
    acction: true,
    createdBy: true,
    lastContent: true,
    status: true,
    interest: true,
    confirmed: true,
  };
  const [listGroup, setlistGroup] = useState({});
  const [openSubTables, setOpenSubTables] = useState({});

  const toggleListGroup = (index, boolean) => {
    setlistGroup((prevStatus) => ({
      ...prevStatus,
      [index]: boolean ? boolean : !prevStatus[index],
    }));
  };

  const toggleSubTable = (indexParent, indexChild) => {
    const key = `${indexParent}_${indexChild}`;
    setOpenSubTables((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const [visibleColumns, setVisibleColumns] = useState(dataInitColumn);
  console.log("visibleColumns", visibleColumns);
  let dataShowTable =
    JSON.parse(localStorage.getItem("dataTableTabAdvise")) || {};
  useEffect(() => {
    if (Object.keys(dataShowTable).length > 0) {
      setVisibleColumns(dataShowTable);
    }
  }, []);
    const isAdmins = isAdmin();
  return (
    <Grid
      container
      spacing={1}
      className="justify-center cards-body"
      style={{ paddingTop: 0, paddingBottom: 0 }}
    >
      <Grid item xs={12}>
        <div className="cards-header flex gap-2">
          <h4 style={{ fontSize: "16px" }}>Danh sách tư vấn</h4>
          <span
            style={{ cursor: "pointer" }}
            className="flex items-center"
            onClick={() => setOpenFillter(!isOpenFillter)}
          >
            <FilterListIcon color="red" />
          </span>
        </div>
      </Grid>

      {!isOpenFillter && (
        <Grid item xs={12}>
          <style>
            {`
                    @keyframes slideDownFade {
                      0% {
                        opacity: 0;
                        transform: translateY(-10px);
                      }
                      100% {
                        opacity: 1;
                        transform: translateY(0);
                      }
                    }
                  `}
          </style>
          <div
            style={{
              animation: "slideDownFade 0.3s ease forwards",
            }}
          >
            <Grid container spacing={1} className="cards-body">
              <Grid item xs={12} sm={6} md={4}>
                <GlobitsMultiDatePicker
                  label="Từ ngày - đến ngày"
                  name="fromDate"
                  range
                  rangeHover
                  fromField="fromDate"
                  toField="toDate"
                  // format={"DD/MM/YYYY"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <GlobitsPagingAutocomplete
                  name={"departmentId"}
                  label={"Cơ sở"}
                  api={pagingDepartment}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="flex flex-end gap-2">
                <Button className="btn-primary" type="submit">
                  <Search />
                  Tìm kiếm
                </Button>
              </Grid>
            </Grid>
          </div>
        </Grid>
      )}

      <Grid item xs={12}>
        <div className="flex justify-end" style={{ padding: "8px" }}>
          <ExtraButton
            setVisibleColumns={setVisibleColumns}
            visibleColumns={visibleColumns}
            columns={columns}
          />
        </div>
        <div className="table-scroll-advise">
          <table className="table-collapse ">
            <thead className="row-table-header">
              {visibleColumns["stt"] && <th>STT</th>}
              {visibleColumns["createdBy"] && <th width="33%">Người tư vấn</th>}
              {visibleColumns["lastContent"] && (
                <th width="40%">Nội dung tư vấn chính</th>
              )}
              {visibleColumns["status"] && <th width="15%">Trạng thái</th>}
            </thead>
            <tbody className="row-table-body">
              {pageAdvise?.content?.length > 0 ? (
                <>
                  {pageAdvise?.content?.map((parent, index) => {
                    return (
                      <>
                        <React.Fragment key={index}>
                          <>
                            <tr>
                              <td
                                colSpan={11}
                                onClick={() => toggleListGroup(index)}
                                className="pointer"
                              >
                                <div className="flex justify-between">
                                  <div className="flex align-center gap-1">
                                    {listGroup[index] ? (
                                      <ExpandMore />
                                    ) : (
                                      <KeyboardArrowRight />
                                    )}
                                    <b>
                                      {getDateTime(
                                        parent?.visit?.startDatetime
                                      )}{" "}
                                      -{" "}
                                      {
                                        STATUS_RESULT_PATIENT_ADVISE.find(
                                          (el) => el?.value === parent?.result
                                        )?.name
                                      }
                                    </b>
                                  </div>
                                  {visibleColumns["acction"] && isAdmins && (
                                    <div className="mr-2 flex-center">
                                      <>
                                        <Tooltip title="Xóa tư vấn">
                                          <div
                                            className="flex"
                                            onClick={() => {
                                              handleClearItemPatientAdvise(
                                                parent
                                              );
                                            }}
                                          >
                                            <IconDelete />
                                          </div>
                                        </Tooltip>
                                      </>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                            {listGroup?.[index] &&
                              parent?.items?.map((child, indexChild) => {
                                const key = `${index}_${indexChild}`;
                                const isOpen = openSubTables[key];
                                let itemStatus =
                                  STATUS_PATIENT_ADVISE?.find(
                                    (it) =>
                                      child?.adviceItemStatus === it?.value
                                  ) || STATUS_PATIENT_ADVISE[0];
                                return (
                                  <>
                                    <React.Fragment key={indexChild}>
                                      {
                                        <>
                                          <tr>
                                            <td
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                toggleSubTable(
                                                  index,
                                                  indexChild
                                                )
                                              }
                                            >
                                              <div className="flex items-center gap-1 pl-6">
                                                <span>{indexChild + 1}</span>
                                                {isOpen ? (
                                                  <ExpandMore />
                                                ) : (
                                                  <KeyboardArrowRight />
                                                )}
                                              </div>
                                            </td>
                                            {visibleColumns["createdBy"] && (
                                              <td>
                                                <i className="text-smaller">
                                                  {getTime(child?.modifyDate)}
                                                </i>
                                                <br></br>
                                                <b>
                                                  {child?.staff?.staffName
                                                    ? `${child?.staff?.staffName}`
                                                    : child?.createdBy}
                                                </b>
                                              </td>
                                            )}
                                            {visibleColumns["lastContent"] && (
                                              <td>
                                                {child?.lastContent ? (
                                                  <>
                                                    <b className="text-old text-smaller">
                                                      {child?.lastContent}
                                                    </b>
                                                    <br />
                                                  </>
                                                ) : (
                                                  ""
                                                )}

                                                {child?.content ? (
                                                  <>
                                                    <b>Nội dung chính : </b>
                                                    {child?.content}
                                                    <br />
                                                  </>
                                                ) : (
                                                  ""
                                                )}

                                                {child?.internalContent ? (
                                                  <>
                                                    <b>Ghi chú : </b>
                                                    {child?.internalContent}
                                                  </>
                                                ) : (
                                                  ""
                                                )}
                                                {child?.attachments?.length >
                                                  0 && (
                                                  <LightGallery
                                                    speed={500}
                                                    plugins={[
                                                      lgThumbnail,
                                                      lgZoom,
                                                      lgFullscreen,
                                                      lgRotate,
                                                    ]}
                                                    mode="lg-fade"
                                                    className="lightgallery-wrapper"
                                                  >
                                                    {child.attachments.map(
                                                      (a) => (
                                                        <ImageLoader
                                                          key={a.id}
                                                          fileId={a.id}
                                                          fetchImage={
                                                            fetchImage
                                                          }
                                                          getImageUrl={
                                                            getImageUrl
                                                          }
                                                          name={a.name}
                                                        />
                                                      )
                                                    )}
                                                  </LightGallery>
                                                )}
                                              </td>
                                            )}

                                            {visibleColumns["status"] && (
                                              <td align="center">
                                                <Tooltip
                                                  title={itemStatus?.name}
                                                >
                                                  {itemStatus?.icon}
                                                </Tooltip>
                                                <br />
                                              </td>
                                            )}
                                          </tr>
                                          {isOpen && (
                                            <tr>
                                              <td></td>
                                              <td
                                                colSpan={3}
                                                style={{
                                                  background: "#f9f9f9",
                                                }}
                                              >
                                                <table className="table-collapse ">
                                                  <thead>
                                                    <tr>
                                                      {visibleColumns[
                                                        "interest"
                                                      ] && <th>Quan tâm</th>}
                                                      {visibleColumns[
                                                        "confirmed"
                                                      ] && <th>Đã chốt</th>}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {[
                                                      {
                                                        label: "SP",
                                                        interest:
                                                          child?.customerInterestedProducts ||
                                                          [],
                                                        confirmed:
                                                          child?.customerConfirmedProducts ||
                                                          [],
                                                        getName: (item) =>
                                                          item?.drug?.name ||
                                                          "Không rõ tên sản phẩm",
                                                      },
                                                      {
                                                        label: "DV",
                                                        interest:
                                                          child?.customerInterestedServices ||
                                                          [],
                                                        confirmed:
                                                          child?.customerConfirmedServices ||
                                                          [],
                                                        getName: (item) =>
                                                          item?.service?.name ||
                                                          "Không rõ tên dịch vụ",
                                                      },
                                                      {
                                                        label: "LT",
                                                        interest:
                                                          child?.customerInterestedTreatmentCards ||
                                                          [],
                                                        confirmed:
                                                          child?.customerConfirmedTreatmentCards ||
                                                          [],
                                                        getName: (item) =>
                                                          item?.clientCard
                                                            ?.name ||
                                                          "Không rõ tên liệu trình",
                                                      },
                                                      {
                                                        label: "Thẻ",
                                                        interest:
                                                          child?.customerInterestedPrepaidCards ||
                                                          [],
                                                        confirmed:
                                                          child?.customerConfirmedPrepaidCards ||
                                                          [],
                                                        getName: (item) =>
                                                          item?.clientCard
                                                            ?.name ||
                                                          "Không rõ tên thẻ",
                                                      },
                                                    ]
                                                      .filter(
                                                        (group) =>
                                                          group.interest
                                                            .length > 0 ||
                                                          group.confirmed
                                                            .length > 0
                                                      )
                                                      .map((group, idx) => (
                                                        <tr key={idx}>
                                                          {visibleColumns[
                                                            "interest"
                                                          ] && (
                                                            <td>
                                                              {group.interest
                                                                .length > 0 ? (
                                                                group.interest.map(
                                                                  (item, i) => (
                                                                    <div
                                                                      key={i}
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        gap: "5px",
                                                                      }}
                                                                    >
                                                                      <span
                                                                        style={{
                                                                          fontWeight:
                                                                            "bold",
                                                                        }}
                                                                      >
                                                                        {
                                                                          group.label
                                                                        }
                                                                        :
                                                                      </span>
                                                                      {group.getName(
                                                                        item
                                                                      )}
                                                                    </div>
                                                                  )
                                                                )
                                                              ) : (
                                                                <i>Không có</i>
                                                              )}
                                                            </td>
                                                          )}
                                                          {visibleColumns[
                                                            "confirmed"
                                                          ] && (
                                                            <td>
                                                              {group.confirmed
                                                                .length > 0 ? (
                                                                group.confirmed.map(
                                                                  (item, i) => (
                                                                    <div
                                                                      key={i}
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        gap: "5px",
                                                                      }}
                                                                    >
                                                                      <span
                                                                        style={{
                                                                          fontWeight:
                                                                            "bold",
                                                                        }}
                                                                      >
                                                                        {
                                                                          group.label
                                                                        }
                                                                        :
                                                                      </span>
                                                                      {group.getName(
                                                                        item
                                                                      )}
                                                                    </div>
                                                                  )
                                                                )
                                                              ) : (
                                                                <i>Không có</i>
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      ))}
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          )}
                                        </>
                                      }
                                    </React.Fragment>
                                  </>
                                );
                              })}
                          </>
                        </React.Fragment>
                      </>
                    );
                  })}
                </>
              ) : (
                <tr>
                  <td colSpan={11} align="center">
                    Chưa có dữ liệu
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Grid>
      <Grid item xs={12}>
        <GlobitsPagination
          pageIndex={searchAdvise.pageIndex}
          pageSize={searchAdvise.pageSize}
          totalElements={pageAdvise?.totalElements}
          totalPages={pageAdvise?.totalPages}
          setPageIndex={(pageIndex) => handleChangeFormSearch({ pageIndex })}
          setPageSize={(pageSize) => handleChangeFormSearch({ pageSize })}
        />
      </Grid>
    </Grid>
  );
};

const ImageLoader = ({ fileId, fetchImage, getImageUrl, name }) => {
  const [imageUrl, setImageUrl] = useState(getImageUrl(fileId));

  useEffect(() => {
    if (!imageUrl) {
      fetchImage(fileId);
      const interval = setInterval(() => {
        const url = getImageUrl(fileId);
        if (url) {
          setImageUrl(url);
          clearInterval(interval);
        }
      }, 200);
      return () => clearInterval(interval);
    }
  }, [fileId, fetchImage, getImageUrl, imageUrl]);

  if (!imageUrl) {
    return (
      <div style={{ width: "100%", padding: "10px", textAlign: "center" }}>
        Đang tải ảnh...
      </div>
    );
  }

  return (
    <a
      href={imageUrl}
      style={{
        width: "calc(50% - 5px)",
        margin: "0 5px 10px 0",
        display: "inline-block",
        boxSizing: "border-box",
      }}
    >
      <img
        src={imageUrl}
        alt={name}
        style={{
          width: "100%",
          borderRadius: 4,
          objectFit: "cover",
          display: "block",
        }}
      />
    </a>
  );
};

const ExtraButton = ({ setVisibleColumns, visibleColumns, columns }) => {
  const classes = useStylesExtraButton();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const visibleColumnsFormat = Object.entries(visibleColumns);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = !!anchorEl ? "simple-popover" : undefined;
  const onToggle = (index, state) => {
    let newArr = visibleColumnsFormat?.map((el, ind) => {
      if (ind === index) return [el[0], state];
      else return el;
    });
    const obj = Object.fromEntries(newArr);
    setVisibleColumns(obj);

    localStorage.setItem("dataTableTabAdvise", JSON.stringify(obj));
    return newArr;
  };

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        color="primary"
        onClick={handleClick}
        className="extra-button-table"
      >
        <div className="flex align-center justify-between">
          {"Xem thêm"}
          <Tooltip title="Xem thêm">
            {!!anchorEl ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
          </Tooltip>
        </div>
      </Button>
      <Popover
        id={id}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Typography className={classes.typography}>
          {visibleColumnsFormat &&
            visibleColumnsFormat?.map((el, index) => (
              <CustomToggle
                el={el}
                onToggle={onToggle}
                index={index}
                columns={columns}
              />
            ))}
        </Typography>
      </Popover>
    </div>
  );
};

const CustomToggle = ({ onToggle, el, index, columns }) => {
  const [active, setActive] = useState(el[1]);

  const handleClick = (index) => {
    setActive((prev) => !prev);
    if (onToggle) {
      onToggle(index, !active);
    }
  };

  return (
    <div className="flex gap-2 align-center toggle-wraper">
      <div className="toggle-container">
        <div
          className={`custom-toggle ${active ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          <div className="toggle-circle" />
        </div>
        <div className="flex justify-between align-center" style={{ flex: 1 }}>
          <span className="toggle-label">{columns[el[0]]}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(observer(ListAdvise));
